<template lang="pug">

  v-form(ref="form" v-model="valid" lazy-validation)
    v-card
      v-card-title
        span.headline {{ $tc('vacation.title', 1) }}
        v-spacer
        v-btn(icon @click="close"): v-icon close
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            v-date-picker.v-date-range__pickers(
              v-model="dates"
              :events="highlightDates"
              :event-color="highlightClasses"
              :min="$moment().format('YYYY-MM-DD')"
              :locale="$i18n.locale"
              first-day-of-week="1"
              no-title
              multiple
            )

      v-card-actions
        v-menu(v-if="data.id" auto)
          template(v-slot:activator="{ on }")
            v-btn(color="red" text v-on="on") {{ $t('ui.delete') }}
          v-list.error
            v-list-item(@click="remove"): v-list-item-title {{ $t('ui.are_you_sure') }}
        v-btn(text @click="close") {{ $t('ui.cancel') }}
        v-spacer
        v-btn(color="blue" text :disabled="!valid" @click="submit") {{ $t('ui.save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default{

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: true,
      errors: {},
      highlightDates: [],
      highlightClasses: {},
      dates: []
    }
  },

  watch: {
    dates(dates, old) {
      if(dates.length < 2 && old.length == 2) this.dates = old
      if(dates.length > 2) {
        const cur = moment(dates[dates.length - 1])
        let min = Number.POSITIVE_INFINITY
        let index
        for(let i = 0; i < dates.length - 1; i++) {
          const diff = Math.abs(cur.diff(moment(dates[i]), 'days'))
          if(diff <= min) {
            min = diff
            index = i
          }
        }
        if(!isNaN(index)) this.dates.splice(index, 1)
      }
      if(this.dates.length == 2) {
        if(this.dates[0] > this.dates[1]) this.dates.sort()
        this.highlight()
      }
    },
  },

  beforeMount() {
    this.name = this.data.name
    if(this.data.id) {
      this.dates.push(this.data.starts_at)
      this.dates.push(this.data.ends_at)
    }
    this.highlight()
  },

  methods: {
    ...mapActions('entities/vacations', {
      createItem: 'createItem',
      updateItem: 'updateItem',
      deleteItem: 'deleteItem',
    }),
    close() {
      this.$emit('close')
    },
    highlight() {
      if(this.dates.length < 2) return
      const dates = []
      const classes = {}
      const start = moment(this.dates[0])
      const end = moment(this.dates[1])
      const diff = end.diff(start, 'days')

      // Loop though all the days in range.
      for (let i = 0; i <= diff; i++) {
        const date = start.clone().add(i, 'days').format('YYYY-MM-DD')
        dates.push(date);
        const classesArr = [];
        classesArr.push(`v-date-range__in-range`);
        classesArr.push(this.highlightColor);
        i === 0 && classesArr.push(`v-date-range__range-start`);
        i === diff && classesArr.push(`v-date-range__range-end`);
        classes[date] = classesArr.join(' ');
      }
      this.highlightDates = dates;
      this.highlightClasses = classes;
    },
    submit() {
      if(this.$refs.form.validate()) {
        const data = {
          starts_at: this.dates[0],
          ends_at: this.dates[1] || this.dates[0],
        }
        if(this.data.id) data.id = this.data.id
        let promise
        if(this.data.id) promise = this.updateItem(data)
        else             promise = this.createItem(data)
        promise
          .then(response => this.$emit('close'))
          .catch(failed => this.errors = failed.errors || {})
      }
    },
    remove() {
      this.deleteItem(this.data).then(response => this.$emit('close'))
    },
  },
}
</script>

<!-- <style scoped lang="sass">
.v-date-range__pickers >>> .v-date-picker-table__events
  width: initial
  height: initial
  left: -3px
  right: -3px
  top: 0
  bottom: 0
  z-index: -1

.v-date-range__pickers >>> .v-date-range__in-range
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  margin: 0
  border-radius: 0
  background-color: #666
  &.v-date-range__range-start, &.v-date-range__range-end
    width: 50%
  &.v-date-range__range-start
    left: initial
    right: 0
  &.v-date-range__range-start.v-date-range__range-end
    width: 0
</style> -->